goog.module('yext.location.FoursquareOffer');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * Models the foursquare offer field.
 *
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
const FoursquareOffer = function($ctx) {
  this.$ctx = $ctx;

  this.$noSpecial = this.$ctx.find('input[value="noSpecial"]');
  this.$custom = this.$ctx.find('input[value="custom"]');
  this.$normalFeatureMsg = this.$ctx.find('input[value="featuredMessage"]');
  this.$editDetails = $ctx.find('.js-foursquare-edit-details');
  this.$normalFeatureMsgNote = $ctx.find('.js-foursquare-featured-msg-note');

  this.$customCheckIn = this.$ctx.find('input[value="checkIn"]');
  this.$customLoyalty = this.$ctx.find('input[value="loyalty"]');
  this.$editTypeDetails = this.$ctx.find('.js-foursquare-edit-type-details');

  this.$loyaltyCount = this.$ctx.find('input[name="foursquare.loyalty.frequency.count1"]');
  this.$description = this.$ctx.find('textarea[name="foursquare.text"]');

  this.$variousMessage = this.$ctx.find('.js-foursquare-edit-various');
  this.$editMain = this.$ctx.find('.js-foursquare-edit-main');

  this.init();
  this.bindType();
  this.bindCustomType();
  this.bindResetAll();
};

/**
 * Stores the model data so that it can be restored later
 */
FoursquareOffer.prototype.init = function() {
  var type = 'noSpecial';
  if (this.$custom.prop('checked')) {
    type = 'custom';
  } else if (this.$normalFeatureMsg.prop('checked')) {
    type = 'featuredMessage';
  }
  var customType;
  if (this.$customCheckIn.prop('checked')) {
    customType = 'checkIn';
  } else if (this.$customLoyalty.prop('checked')) {
    customType = 'loyalty';
  }

  this.model = {
    'type': type,
    'customType': customType,
    'loyaltyCount': this.$loyaltyCount.val(),
    'description': this.$description.val(),
    'indeterminate': this.$variousMessage.length ? true : false,
  };
};

/**
 * Bind the type options
 */
FoursquareOffer.prototype.bindType = function() {
  var self = this;

  this.$noSpecial.change(function() {
    self.$editDetails.hide();
    self.$normalFeatureMsgNote.hide();
    self.message('updated');
  });

  this.$custom.change(function() {
    self.$editDetails.show();
    self.$normalFeatureMsgNote.hide();
    self.message('updated');
  });

  this.$normalFeatureMsg.change(function() {
    self.$editDetails.hide();
    self.$normalFeatureMsgNote.show();
    self.message('updated');
  });
};

/**
 * Bind the two customized radio options and input changes
 */
FoursquareOffer.prototype.bindCustomType = function() {
  var self = this;

  this.$ctx.find('.js-loyalty-count').inputchange(function() {
    self.message('updated');
  });

  this.$ctx.find('.js-special-description').inputchange(function() {
    self.message('updated');
  });

  this.$customCheckIn.change(function() {
    self.$editTypeDetails.hide();
    self.message('updated');
  });

  this.$customLoyalty.change(function() {
    self.$editTypeDetails.show();
    self.message('updated');
  });
};

/**
 * Bind the "Reset all" link in bulk edit indeterminate mode
 */
FoursquareOffer.prototype.bindResetAll = function() {
  var self = this;

  this.$ctx.find('.js-foursquare-reset-all').click(function() {
    self.$variousMessage.hide();
    self.$editMain.show();
  });
};

/**
 * Publish a message with the field as the context
 *
 * @param {string} message Message to trigger
 */
FoursquareOffer.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset edit mode based on stored value
 */
FoursquareOffer.prototype.reset = function() {
  this.render(this.model);
};

/**
 * Set the model based on the passed in data and render edit mode
 */
FoursquareOffer.prototype.set = function(data) {
  this.model = data;
  this.render(data);
};

/**
 * Render edit mode using the passed in data
 *
 * @param {!Object} data
 */
FoursquareOffer.prototype.render = function(data) {
  if (data.indeterminate) {
    this.$variousMessage.show();
    this.$editMain.hide();
    return;
  }

  this.$noSpecial.prop('checked', false);
  this.$custom.prop('checked', false);
  this.$normalFeatureMsg.prop('checked', false);
  this.$customCheckIn.prop('checked', false);
  this.$customLoyalty.prop('checked', false);

  this.$editDetails.hide();
  this.$normalFeatureMsgNote.hide();
  this.$editTypeDetails.hide();

  // Render edit mode based on data
  var type = data.type;
  if (type === 'noSpecial') {
    this.$noSpecial.prop('checked', true);
  } else if (type === 'custom') {
    this.$custom.prop('checked', true);
    this.$editDetails.show();
  } else if (type === 'featuredMessage') {
    this.$normalFeatureMsg.prop('checked', true);
    this.$normalFeatureMsgNote.show();
  }

  var customType = data.customType;
  if (customType === 'checkIn') {
    this.$customCheckIn.prop('checked', true);
  } else if (customType === 'loyalty') {
    this.$customLoyalty.prop('checked', true);
    this.$editTypeDetails.show();
  }

  this.$loyaltyCount.val(data.loyaltyCount);
  this.$description.val(data.description);
};

/**
 * Get the display value of the field
 */
FoursquareOffer.prototype.getDisplayValue = function() {
  if (this.model.type === 'noSpecial') {
    return yext.msg('Do not display a Foursquare special');
  } else if (this.model.type === 'featuredMessage') {
    return yext.msg('Use my normal featured message as a Foursquare check-in special');
  } else if (this.model.type === 'custom') {
    var display = '<div class="foursquare-special-description">';
    if (this.model.customType === 'checkIn') {
      display += '<div style="font-weight: bolder">' + yext.msg('Check-in special') + '</div><div>' + yext.msg('Anyone who checks in unlocks the special.') + '</div>';
    } else if (this.model.customType === 'loyalty') {
      display += '<div style="font-weight: bolder">' + yext.msg('Loyalty special') + '</div><div>' +
        yext.msgn('A customer unlocks the special every 1 check-in', 'A customer unlocks the special every {0} check-ins', this.model.loyaltyCount) + '</div>';
    }
    display += '</div><div><div style="font-weight: bolder">' + yext.msg('Offer description') + '</div><div>' + helpers.escapeInput(this.model.description) + '</div></div>';
    return display;
  }
};

exports = FoursquareOffer;
